import s from './Level.module.scss';
import cn from 'classnames';

interface Props {
    max: number;
    current: string;
}

const Level = ({ max, current }: Props) => {
    const curr = parseInt(current);

    return (
        <div className={s.rt}>
            <div className={s.txt}>דרגת קושי:</div>
            <div className={s.lvls}>
                <svg
                    width="91"
                    height="2"
                    viewBox="0 0 91 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0.164062 0.855469H90.2672"
                        stroke="white"
                        strokeWidth="1.56701"
                    />
                </svg>
                <div className={cn(s.lvl, { [s.lvl_hide]: curr + 1 > max })}>
                    {curr + 1}
                </div>
                <div className={s.lvl_act}>{current}</div>
                <div className={cn(s.lvl, { [s.lvl_hide]: curr - 1 < 1 })}>
                    {curr - 1}
                </div>
            </div>
        </div>
    );
};

export default Level;
